enum MouseState {
  INVALID,
  MOVE,
  SELECT,
  ADD,
  LINK,
}

export default MouseState;
